module.exports = __webpack_public_path__ + "img/technology-4.e71a4934.png";